<template>
  <div class="Extension padding">

    <h1>
      Web extension
    </h1>

    <!--p>
      The <a href="https://chrome.google.com/webstore/detail/textify/bmgeoickdkceegcemaohalboegigahbg" target="_blank">Textify web extension for Chrome</a> let's you display captions in any browser window and tab.
    </p-->

    <div class="columns flex-space-around">

      <div>
        <h2>Features</h2>
        <ul>
          <li>
            Easily enter and exit Textify rooms.
          </li>
          <li>
            Show Textify captions in any browser window.
          </li>
          <li>
            Choose which browser windows should display the captions.
          </li>
        </ul>
      </div>

      <div>
        <h2>Use cases</h2>
        <ul>
          <li>
            Show live captions in popular browser video conference tool, e.g. Zoom, Google Meet and Jitsi.
          </li>
          <li>
            Overlay captions on any web content, e.g. video live streams of presentations, seminars and speeches.
          </li>
          <li>
            Run Textify in a hidden window and focus on your own tasks; the captions will follow you.
          </li>
        </ul>
      </div>

    </div>

    <hr />

    <div class="columns center flex-center">
      <div>
        <p>
          Get <a href="https://chrome.google.com/webstore/detail/textify/bmgeoickdkceegcemaohalboegigahbg" target="_blank">Textify web extension for Chrome</a>.
        </p>
        <p class="small">
          More browsers will be supported soon.
        </p>
      </div>
      <div>
        Get inspired by <router-link :to="{ name: 'Features'}">features and example use cases</router-link>!
        <p class="gray small">
          Missing something? <router-link to="/features#request">Request a feature</router-link>.
        </p>
      </div>
    </div>

    <div>

    </div>


    <hr />

    <h3>Found a bug?</h3>
    <p>
       Please contact me at <a href="mailto:martin@interaktivarum.se">martin@interaktivarum.se</a>.
    </p>

  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Extension',
  components: {
  },
  data: function () {
    return {
    }
  },
  methods: {
  },
  mounted: function () {
  }
}
</script>

<style lang="scss" scoped>

.columns{
  flex-wrap: wrap;
}

.columns > div{
  flex: 1 0 200px;
  margin-right: 10px;
}

</style>
